import * as React from 'react';

export const useCountSelectedDates = () => {
  /** Индекс текущей выбранной даты. Нужно, чтобы отслеживать, какая по счету дата выбрана.
   *  Если selectedDatesCount = 1, то первая дата (заезда/выезда), если selectedDatesCount = 2, то выбраны обе даты
   * */
  const selectedDatesCount = React.useRef(0);

  const countSelectedDates = React.useCallback(() => {
    if (selectedDatesCount.current === 2) {
      selectedDatesCount.current = 1;
    } else {
      selectedDatesCount.current += 1;
    }
  }, []);

  const setDefaultCountState = React.useCallback((state: 0 | 1 | 2 = 0) => {
    selectedDatesCount.current = state;
  }, []);

  return React.useMemo(() => ({ selectedDatesCount, countSelectedDates, setDefaultCountState }), []);
};
